// src/api/strapi.js
import axios from "axios";

// const API_URL = "http://localhost:1337/api";
const API_URL = "https://ecl-cms-5d0d78c9e9b5.herokuapp.com/api";

const strapi = axios.create({
  baseURL: API_URL,
});

export async function fetchFromStrapi(endpoint) {
  try {
    const res = await strapi.get(`${endpoint}?populate=*`);
    return res.data;
  } catch (err) {
    console.error(`Failed to fetch ${endpoint}:`, err.message);
    throw err;
  }
}

// POST (JSON)
export async function postToStrapi(endpoint, payload, config = {}) {
  try {
    const res = await strapi.post(endpoint, payload, {
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
      ...config,
    });

    return res.data;
  } catch (err) {
    console.error(`Failed to post to ${endpoint}:`, err.message);
    throw err;
  }
}

// File upload (multipart/form-data)
export async function uploadFile(file) {
  const formData = new FormData();
  formData.append("files", file);

  try {
    const res = await strapi.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (err) {
    console.error("File upload failed:", err.message);
    throw err;
  }
}


export default strapi;
